// constants.js

export const FIELD_TYPES = [
    'string',
    'richtext',
    'barcode',
    'phone',
    'email',
    'measurement',
    'enum',
    'multiselect',
    'people',
    'nodelist',
    'annualdate',
    'date',
    'daterange',
    'datetime',
    'datetimerange',
    'cover',
    'icon',
    //'color',
    'description',
    'location',
    'boolean',
    'number',
    'percentage',
    'currency',
    'url',
    'checklist',
    'tags',
    'comments',
    'activity',
];

export const ONCE_ONLY_FIELD_TYPES = [
    'cover',
    'icon',
    //'color', 
    'description',
    'checklist',
    'comments',
    'activity'
];

export const FIELD_TYPE_LABELS = {
    cover: 'Cover Photo',
    icon: 'Icon',
    //color: 'Identity Color',
    description: 'Description',
    barcode: 'Bar Code',
    string: 'Text',
    phone: 'Phone Number',
    email: 'Email',
    measurement: 'Measurement',
    annualdate: 'Annual Date',
    date: 'Date',
    daterange: 'Date Range',
    datetime: 'Date and Time',
    datetimerange: 'Date and Time Range',
    enum: 'Select',
    multiselect: 'Multi-Select',
    location: 'Location',
    boolean: 'True / False',
    number: 'Number',
    percentage: 'Percentage',
    currency: 'Currency',
    nodelist: 'Related Items',
    url: 'URL',
    people: 'People',
    checklist: 'Checklists',
    tags: 'Tags',
    comments: 'Comments',
    activity: 'Activity',
    richtext: 'Rich Text',
};

export const FIELD_TYPE_DESCRIPTIONS = {
    barcode: 'A barcode value with manual entry, paste, and camera scanning.',
    string: 'Plain text for names, titles, or short answers.',
    phone: 'A phone number with US-first formatting.',
    email: 'An email address with lowercase canonical storage.',
    measurement: 'A decimal value paired with a unit selected from your list.',
    boolean: 'A yes or no value.',
    number: 'A numeric value.',
    enum: 'Choose a single option from a predefined list.',
    multiselect: 'Choose one or more options from a predefined list.',
    people: 'Reference one or more space members.',
    nodelist: 'Link related items from another database.',
    annualdate: 'Useful for recurring dates, like birthdays or holidays.',
    date: 'A specific calendar date without a time.',
    daterange: 'A specific start and end date.',
    datetime: 'A specific date and time.',
    datetimerange: 'A specific start and end date with times.',
    cover: 'Main cover image for this item type.',
    icon: 'Optional icon override for individual records in this database.',
    //color: 'An optional node identity color used as a subtle accent in operational views.',
    description: 'Built-in node summary used in list items, previews, and other system surfaces.',
    richtext: 'Formatted body text with headings, emphasis, and embedded content blocks.',
    location: 'Place or address details.',
    percentage: 'A numeric percentage with optional snap increments.',
    currency: 'A monetary amount.',
    url: 'A website or external link.',
    checklist: 'Enable one or more checklists on this item.',
    tags: 'One or more lightweight labels.',
    comments: 'Built-in discussion thread for the item.',
    activity: 'Built-in activity feed for changes and events.',
};

export const DEFAULT_LABELS_BY_TYPE = {
    cover: 'Cover Photo',
    icon: 'Icon',
    //color: 'Identity Color',
    description: 'Description',
    barcode: 'Bar Code',
    annualdate: 'Annual Date',
    date: 'Date',
    daterange: 'Date Range',
    datetime: 'Date and Time',
    datetimerange: 'Date and Time Range',
    location: 'Location',
    phone: 'Phone Number',
    email: 'Email',
    url: 'Website',
    people: 'People',
    nodelist: 'Related Items',
    checklist: 'Checklists',
    tags: 'Tags',
    comments: 'Comments',
    activity: 'Activity',
};

export const DEFAULT_VALUE_UNSUPPORTED_TYPES = [
    'cover',
    //'color', 
    'location',
    'annualdate',
    'date',
    'daterange',
    'datetime',
    'datetimerange',
    'people',
    'nodelist',
    'checklist',
    'tags',
    'multiselect',
    'measurement',
    'richtext',
    'url',
    'comments',
    'activity'
];

export const ENUM_OPTIONS_SORT_MODE_MANUAL = 'manual';
export const ENUM_OPTIONS_SORT_MODE_LABEL_ASC = 'label_asc';
export const ENUM_OPTIONS_SORT_MODE_LABEL_DESC = 'label_desc';

export const ENUM_OPTIONS_SORT_MODE_OPTIONS = [
    { value: ENUM_OPTIONS_SORT_MODE_MANUAL, label: 'Manual (original order)' },
    { value: ENUM_OPTIONS_SORT_MODE_LABEL_ASC, label: 'Label (A to Z)' },
    { value: ENUM_OPTIONS_SORT_MODE_LABEL_DESC, label: 'Label (Z to A)' },
];

export const makeDraft = () => ({
    label: '',
    fieldDescription: '',
    type: 'string',
    targetType: '',
    default: '',
    defaultUnit: '',
    options: [],
    enumOptionsSort: ENUM_OPTIONS_SORT_MODE_MANUAL,
});
